import { Button, DatePicker, Form, Select } from "antd";
import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { ECapReportStepProps } from ".";
import { DateFormat, ReportTypeEnum, VALIDATION_MESSAGE_CONFIG } from "../../../../constants/constants";

const planingCycleYears = () => {
    const now = new Date();
    const currentYear = now.getFullYear();
    const years = [];
    for (let index = currentYear - 5; index < currentYear + 5; index++) {
        years.push(index);
    }
    return years;
}

const quarters = [1, 2, 3, 4];

const SelectPeriod = (props: ECapReportStepProps) => {

    const { t } = useTranslation();
    const years = useRef(planingCycleYears());

    const formSubmit = (values: any) => {

        if (props.next) {
            props.next(values);
        }
    }

    useEffect(() => {
    }, [])

    return (
        <div className="step-content-item-wrapper">

            <div className="step-content-item-header">
                <h4>
                    {t("RapmReport.lbSelectPeriod")}
                </h4>
            </div>

            <Form
                layout='vertical'
                validateMessages={VALIDATION_MESSAGE_CONFIG}
                onFinish={(values) => formSubmit(values)}
                initialValues={{ fiscal_year: new Date().getFullYear() }}
                scrollToFirstError>
                <Form.Item
                    label={t("RapmReport.lbFiscalYear")}
                    name="fiscal_year"
                    rules={[{ required: true }]}>
                    <Select>
                        {years.current && years.current.map((item, index) => (
                            <Select.Option key={index} value={item}>
                                {item}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>

                {
                    props.risk_type === ReportTypeEnum.Ramp &&
                    <React.Fragment>
                        <Form.Item
                            label={t("RapmReport.lbQuarter")}
                            rules={[{ required: true }]}
                            name="quarter">
                            <Select placeholder={t("Global.plPleaseSelect")}>
                                {quarters && quarters.map((item, index) => (
                                    <Select.Option key={index} value={item}>
                                        {item}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>

                        <Form.Item
                            label={t("RapmReport.lbInitialDate")}
                            name="initial_date"
                            rules={[{ required: true }]}>
                            <DatePicker format={DateFormat.view} placeholder={t("Global.plPleaseSelect")} />
                        </Form.Item>

                    </React.Fragment>


                }

                <Form.Item
                    label={t("RapmReport.lbReportDueDate")}
                    name="due_date"
                    rules={[{ required: true }]}>
                    <DatePicker format={DateFormat.view} placeholder={t("Global.plPleaseSelect")} />
                </Form.Item>

                <Form.Item>
                    <Button htmlType="submit" type="primary" shape="round" block>
                        {
                            t("RapmReport.btnNext")
                        }
                    </Button>
                </Form.Item>

            </Form>

        </div>
    )
}

export default SelectPeriod;